import { useUnifiedUserInfo } from '@/utils/auth/userInfo';

/**
 * Dashboard welcome banner — greets the logged-in user by name.
 * No "Mode Demo" button: this is the real production dashboard.
 */
export const WelcomeBanner = () => {
  const userInfo = useUnifiedUserInfo();
  const name = userInfo?.name || 'Pengguna';

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-[#1848FD] to-[#0A2A8C] px-6 py-8 text-white md:px-10 md:py-10">
      <div className="relative z-10 max-w-2xl pr-24">
        <h2 className="text-2xl font-bold md:text-3xl line-clamp-2">
          Selamat datang, {name}! <span className="inline-block">👋</span>
        </h2>
        <p className="mt-3 text-sm text-blue-100 md:text-base xl:truncate">
          Mari selesaikan perancangan dan implementasi AOS untuk membangun sistem bisnis yang kuat dan terstruktur.
        </p>
      </div>

      {/* Decorative background circle */}
      <svg
        className="pointer-events-none absolute bottom-0 right-4 hidden h-full w-64 opacity-80 md:block"
        viewBox="0 0 240 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="200" cy="80" r="55" fill="#ffffff" opacity="0.06" />
      </svg>
    </div>
  );
};
